/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    DownloadTemplate() {
        return HttpService.get(environment.API_IMPORT_CONSENT + `/template`, {
            responseType: 'blob',
        });
    },
    DownloadTemplateId(id) {
        return HttpService.get(
            environment.API_IMPORT_CONSENT + `/history/${id}`,
            { responseType: 'blob' }
        );
    },
    UploadConsent(payload, onUploadProgress) {
        return HttpService.post(
            environment.API_IMPORT_CONSENT + `/template`,
            payload,
            {
                onUploadProgress,
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                },
            }
        );
    },
    ImportHistory(params) {
        return HttpService.get(environment.API_IMPORT_CONSENT + `/history`, {
            params,
        });
    },
};
